import { render, staticRenderFns } from "./SwabSampleAnalysisPageHeader.vue?vue&type=template&id=305decb0&scoped=true&"
import script from "./SwabSampleAnalysisPageHeader.vue?vue&type=script&lang=ts&"
export * from "./SwabSampleAnalysisPageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SwabSampleAnalysisPageHeader.vue?vue&type=style&index=0&id=305decb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305decb0",
  null
  
)

export default component.exports